import createAxios from 'config/axios'

const logout = () => createAxios.post('auth/v2/security/user/logout')

export default logout
